import { RentalPortalApplicantProfileWidgetStageScreening } from '../../../RentalPortalApplicantProfileWidgetStageScreening'
import { APPLICANT_PROFILE_WIDGET_KEY } from '../../RentalPortalApplicantProfileWidgetList.constants'

export function useApplicantProfileWidgets() {
  const widgets = {
    [APPLICANT_PROFILE_WIDGET_KEY.stageScreening]: (
      <RentalPortalApplicantProfileWidgetStageScreening />
    ),
  }

  return { widgets }
}
